<script lang="ts">
	import { getContext, onDestroy, onMount } from 'svelte';
	import type { UserStore } from '$lib/stores/user';
	import { browser } from '$app/environment';
	import { t } from '@riva-mono/common';
	import Dropdown from './Dropdown.svelte';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';

	const userStore: UserStore = getContext('user');
	let showMenu = $state(false);
	let dialog: HTMLDialogElement | null;

	const handleMenuClick = (e: Event) => {
		const target = e.target as HTMLElement;
		if (!target.closest('.menu')) {
			showMenu = false;
			e.preventDefault();
			e.stopPropagation();
		}
		return false;
	};

	const showProfile = () => {
		showMenu = false;
		document.body.addEventListener('touchmove', preventDefault);
		document.body.style.overflow = 'hidden';
		dialog?.showModal();
	};

	function preventDefault(event: Event) {
		event.preventDefault();
	}

	$effect(() => {
		if (!showMenu && browser) {
			window.removeEventListener('mousedown', handleMenuClick, true);
		}
	});

	onDestroy(() => {
		if (browser) {
			window.removeEventListener('mousedown', handleMenuClick, true);
		}
	});

	onMount(() => {
		dialog = document.querySelector('#profileDialog');
	});
</script>

<Dropdown direction="right" triggerStyle="padding:0;">
	<svg width="39" height="35" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle
			cx="16.2891"
			cy="7.56989"
			r="5.615"
			fill="transparent"
			fill-opacity="0.3"
			stroke="#511F3A"
			style="fill-opacity:0.3;stroke:#511F3A;stroke:color(display-p3 0.3176 0.1216 0.2275);stroke-opacity:1;"
			stroke-width="2"
			stroke-linecap="round"
		/>
		<path
			d="M1.26947 31.984C1.26947 30.0116 1.65796 28.0585 2.41277 26.2363C3.16758 24.414 4.27392 22.7582 5.66862 21.3635C7.06332 19.9688 8.71907 18.8625 10.5413 18.1077C12.3636 17.3529 14.3167 16.9644 16.2891 16.9644C18.2615 16.9644 20.2146 17.3529 22.0369 18.1077C23.8591 18.8625 25.5149 19.9688 26.9096 21.3635C28.3043 22.7582 29.4106 24.414 30.1654 26.2363C30.9202 28.0585 31.3087 30.0116 31.3087 31.984"
			stroke="#511F3A"
			style="stroke:#511F3A;stroke:color(display-p3 0.3176 0.1216 0.2275);stroke-opacity:1;"
			stroke-width="2"
			stroke-linecap="round"
		/>
	</svg>
	{#snippet menu()}
		<div>
			<button class="button item" onclick={showProfile}>{$t('common.navigation.profile')}</button>
			<button
				class="button item"
				onclick={() => {
					goto(`/${$page.params.lang}/booking`);
				}}>{$t('common.navigation.dashboard')}</button
			>
			<!-- {#if $page.route.id?.includes('/questionnaire')}
					<button
						class="item"
						on:click={() => {
							goto(`/${$page.params.lang}/`);
						}}>Rivamedical.com</button
					>
				{/if} -->
			<a href="/signout" class="button item">{$t('common.navigation.logout')}</a>
		</div>
	{/snippet}
</Dropdown>

<style>
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.item {
		white-space: nowrap;
		font-weight: 700;
		padding: 0.5rem 1rem;
		background: var(--white);
		border: unset;
		text-align: left;
		border-radius: unset;
		width: calc(100% - 0.5rem);
		justify-content: flex-start;
		border-radius: 0.8rem;
		margin: 0 0.25rem;
	}

	.item:hover {
		background: var(--primary-color-5);
	}
</style>
